/**
 * @description Initialize HTML5 video elements in video player components
 * Ensures video elements work correctly with dynamically set attributes
 */
window.$ = require('jquery');

$(document).ready(function () {
    function initVideoPlayer(videoContainer) {
        if (!videoContainer) {
            return;
        }

        const video = videoContainer.querySelector('video');
        if (!video) {
            return;
        }

        // Ensure video attributes are properly applied
        // Attributes are set server-side, but we ensure they work correctly client-side

        // Handle autoplay with mute (browser requirement)
        if (video.hasAttribute('autoplay') && !video.hasAttribute('muted')) {
            // Some browsers require muted for autoplay to work
            video.muted = true;
        }

        // Ensure loop works correctly
        if (video.hasAttribute('loop')) {
            video.loop = true;
        }

        // Ensure controls are properly displayed
        if (video.hasAttribute('controls')) {
            video.controls = true;
        }

        // Ensure muted state is applied
        if (video.hasAttribute('muted')) {
            video.muted = true;
        }
    }

    function scanAndInitVideoPlayers() {
        try {
            const videoContainers = document.querySelectorAll('.video-container');
            if (!videoContainers || !videoContainers.length) {
                return;
            }
            videoContainers.forEach(initVideoPlayer);
        } catch (err) {
            // Silently fail if there's an error
        }
    }

    // Initialize on page load
    scanAndInitVideoPlayers();

    // Re-scan after a delay to catch dynamically loaded content
    setTimeout(scanAndInitVideoPlayers, 1000);

    // Watch for new video containers added to the DOM
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.classList && node.classList.contains('video-container')) {
                    initVideoPlayer(node);
                } else if (node.querySelectorAll) {
                    node.querySelectorAll('.video-container').forEach(initVideoPlayer);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
